import React, { useEffect, useState } from 'react';
import { Modal, Tooltip, Tabs, Checkbox } from 'antd';
import { SpanButton } from 'component/button_components/button.style';
import { ReactComponent as ViewIcon } from 'assets/images/SVG/icons/view-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { getOneUser } from 'redux/slices/createUser';
import {
  Data,
  DataContainer,
  Label,
  UserStatusBottomWrap,
  UserStatusContent,
  UserStatusContentWrap,
  UserStatusWrap,
  ViewRowWrapper,
  ViewUserConatiner,
} from './style';
import TabPane from 'antd/es/tabs/TabPane';
import { getAttributes, getLockOrDisable } from 'redux/slices/userSlice';
import { Link } from 'react-router-dom';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';

const ViewUser = ({ ...record }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [lockDisable, setLockDisable] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [singleUserData, setSingleUserData] = useState(null);
  const selectedNode = useSelector((state) => state.selectedNode);
  const { userAttributes } = useSelector((state) => state.getUsers);
  const additionalInitialValues = userAttributes.reduce((acc, field) => {
    const attribute = singleUserData?.attributes.find((attr) => attr[field] !== undefined);
    acc[field] = attribute ? attribute[field] : '';
    return acc;
  }, {});
  useEffect(() => {
    if (isModalOpen) {
      dispatch(getAttributes(selectedNode.currentdomainId));
    }
  }, [isModalOpen]);
  const showModal = async () => {
    try {
      const sweetAlert = await dispatch(
        getOneUser({ userName: record.dn, fqdn: selectedNode.domainName, domainId: selectedNode.currentdomainId })
      );
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        setSingleUserData(sweetAlert.payload.data);
        setIsModalOpen(true);
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleStatus = async () => {
    let typeNumber;
    if (!singleUserData.isEnabled && singleUserData.isLock) {
      typeNumber = 3;
    } else if (singleUserData.isLock) {
      typeNumber = 2;
    } else if (!singleUserData.isEnabled) {
      typeNumber = 1;
    }
    const values = {
      user: record.dn,
      fqdn: selectedNode.domainName,
      type: typeNumber,
    };
    try {
      setLoading(true);
      const response = await dispatch(getLockOrDisable(values));
      if (response?.payload?.status === 200) {
        setLockDisable(response.payload.data);
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  };

  const renderAdditionalFields = () => {
    return userAttributes.map((field, index) => {
      if (!Array.isArray(userAttributes) || userAttributes.length === 0) {
        return null;
      }

      const isOdd = index % 2 === 0 && userAttributes.length % 2 !== 0 && index === userAttributes.length - 1;

      // Only render the row wrapper for even index
      if (index % 2 === 0) {
        return (
          <ViewRowWrapper
            key={`row-wrapper-${index + 3}`}
            className={`viewuser-wrap viewuser-wrap-${index + 3} ${isOdd ? 'oddnumber' : ''}`}
          >
            <DataContainer className={`viewuser-item viewuser-item-${field}`}>
              <Label style={{ textTransform: 'capitalize' }} className={`viewuser-label viewuser-label-${field}`}>
                {field}:
              </Label>
              <Data className={`viewuser-data viewuser-data-${field}`}>{additionalInitialValues[field]}</Data>
            </DataContainer>
            {userAttributes[index + 1] && (
              <DataContainer className={`viewuser-item viewuser-item-${userAttributes[index + 1]}`}>
                <Label
                  style={{ textTransform: 'capitalize' }}
                  className={` viewuser-label viewuser-label-${userAttributes[index + 1]}`}
                >
                  {userAttributes[index + 1]}:
                </Label>
                <Data className={`viewuser-data viewuser-data-${userAttributes[index + 1]}`}>
                  {additionalInitialValues[userAttributes[index + 1]]}
                </Data>
              </DataContainer>
            )}
          </ViewRowWrapper>
        );
      }
      return null;
    });
  };

  return (
    <>
      <Tooltip className='action-tooltip action-tooltip-user' title='View User' color='#597081'>
        <SpanButton className='action-spanbutton action-spanbutton-user' onClick={showModal}>
          <ViewIcon className='action-icon action-icon-user-view' />
        </SpanButton>
      </Tooltip>
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          width={800}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={false}
          centered
          maskClosable={false}
          style={{ minHeight: 362 }}
          className='modal-style modal-viewuser'
        >
          {loading && <ModalOpenLoader />}
          <UserStatusWrap className='af-viewuser-status-section-wrap'>
            <div className='af-viewuser-status-dummy'></div>
            <UserStatusContentWrap className='af-viewuser-status-content-wrap'>
              <UserStatusContent className='af-viewuser-status-content'>
                <h4 className='af-viewuser-status-header'>Status:</h4>
                <span className='af-viewuser-status' style={{ display: 'flex' }}>
                  <p
                    className='af-viewuser-status-lock'
                    style={{ color: singleUserData.isLock ? 'darkred' : 'darkgreen' }}
                  >
                    {singleUserData.isLock
                      ? `Locked ${lockDisable && '(' + lockDisable.lockedDateTime + ')'}`
                      : 'Unlocked'}
                  </p>
                  &nbsp;<p className='af-viewuser-status-slash'>/</p>&nbsp;
                  <p
                    className='af-viewuser-status-disable'
                    style={{ color: singleUserData.isEnabled ? 'darkgreen' : 'darkred' }}
                  >
                    {singleUserData.isEnabled
                      ? 'Enabled'
                      : `Disabled ${lockDisable && '(' + lockDisable.disableDateTime + ')'}`}
                  </p>
                </span>
              </UserStatusContent>
              {!lockDisable && (singleUserData.isLock || !singleUserData.isEnabled) && (
                <div className='af-viewuser-status-datetime-wrap'>
                  <Link
                    className='af-viewuser-status-datetime'
                    style={{ textDecoration: 'underline' }}
                    onClick={handleStatus}
                  >
                    Get Time?
                  </Link>
                </div>
              )}
              {/* <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <h4>Last Logon:</h4>
                <span>{singleUserData.lastLogon}</span>
              </div> */}
            </UserStatusContentWrap>
          </UserStatusWrap>
          <h2 className='modal-viewuser-heading'>
            {singleUserData.displayName ? singleUserData.displayName : singleUserData.samAccountName}
          </h2>
          <ViewUserConatiner className='viewuser-container'>
            <Tabs
              className='af-form-tab af-viewuser-form-tab'
              activeKey={activeTab}
              defaultActiveKey='1'
              onChange={handleTabChange}
              tabPosition='top'
              tabBarGutter={20}
            >
              <TabPane
                tab='Account'
                key='1'
                className='af-form-tab-tabpane af-viewuser-form-tab-tabpane af-viewuser-form-tab-tabpane_account'
              >
                <ViewRowWrapper className='elemtwrapuser viewuser-wrap viewuser-wrap-wrap1'>
                  <DataContainer className='mediumlength viewuser-item viewuser-item-first_name'>
                    <Label className='viewuser-label viewuser-label-first_name'>First Name: </Label>
                    <Data className='viewuser-data viewuser-data-first_name'>{singleUserData?.givenName}</Data>
                  </DataContainer>
                  <DataContainer className='mediumlength viewuser-item viewuser-item-initial'>
                    <Label className='viewuser-label viewuser-label-initial'>Initial: </Label>
                    <Data className='viewuser-data viewuser-data-initial'>{singleUserData?.initials}</Data>
                  </DataContainer>
                  <DataContainer className='mediumlength viewuser-item viewuser-item-last_name'>
                    <Label className='viewuser-label viewuser-label-last_name'>Last Name: </Label>
                    <Data className='viewuser-data viewuser-data-last_name'>{singleUserData?.surname}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap2'>
                  <DataContainer className='viewuser-item viewuser-item-display_name'>
                    <Label className='viewuser-label viewuser-label-display_name'>Display Name: </Label>
                    <Data className='viewuser-data viewuser-data-display_name'>{singleUserData?.displayName}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-email'>
                    <Label className='viewuser-label viewuser-label-email'>E-mail: </Label>
                    <Data className='viewuser-data viewuser-data-email'>{singleUserData?.email}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap3'>
                  <DataContainer className='viewuser-item viewuser-item-upn'>
                    <Label className='viewuser-label viewuser-label-upn'>UPN: </Label>
                    <Data className='viewuser-data viewuser-data-upn'> {singleUserData?.userPrincipalName}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-sam_name'>
                    <Label className='viewuser-label viewuser-label-sam_name'>SAM Account Name: </Label>
                    <Data className='viewuser-data viewuser-data-sam_name'>{singleUserData?.samAccountName}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap4'>
                  <DataContainer className='viewuser-item viewuser-item-status'>
                    <Label className='viewuser-label viewuser-label-status'>Status: </Label>
                    <Data className='viewuser-data viewuser-data-status'>
                      {singleUserData?.isLock === false ? 'Unlocked' : 'Locked'}
                    </Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-password_expiry'>
                    <Label className='viewuser-label viewuser-label-password_expiry'>Password Expiry: </Label>
                    <Data className='viewuser-data viewuser-data-password_expiry'>{singleUserData?.expire}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap5'>
                  <DataContainer className='singlelabel viewuser-item viewuser-item-ou'>
                    <Label className='viewuser-label viewuser-label-ou'>OU: </Label>
                    <Data className='viewuser-data viewuser-data-ou'> {singleUserData?.ouName}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap6'>
                  <DataContainer className='singlelabel viewuser-item viewuser-item-group'>
                    <Label className='viewuser-label viewuser-label-group'>Groups: </Label>
                    <Data className='viewuser-data viewuser-data-group'>{singleUserData?.groupNames.join(',')}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <div>
                  <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap7'>
                    <DataContainer className='viewuser-item viewuser-item-passwordAtNextLogon'>
                      <Checkbox
                        className='viewuser-checkbox viewuser-checkbox-passwordAtNextLogon'
                        value='passwordAtNextLogon'
                        checked={singleUserData?.passwordAtNextLogon}
                        disabled
                      ></Checkbox>
                      <span className='viewuser-checkbox-caption' style={{ marginLeft: '10px' }}>
                        User must change password on next login
                      </span>
                    </DataContainer>
                    <DataContainer className='viewuser-item viewuser-item-userCannotChangePassword'>
                      <Checkbox
                        className='viewuser-checkbox viewuser-checkbox-userCannotChangePassword'
                        value='userCannotChangePassword'
                        checked={singleUserData?.userCannotChangePassword}
                        disabled
                      ></Checkbox>
                      <span className='viewuser-checkbox-caption' style={{ marginLeft: '10px' }}>
                        User cannot change password
                      </span>
                    </DataContainer>
                  </ViewRowWrapper>
                  <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap8'>
                    <DataContainer className='viewuser-item viewuser-item-passwordNeverExpires'>
                      <Checkbox
                        className='viewuser-checkbox viewuser-checkbox-passwordNeverExpires'
                        value='passwordNeverExpires'
                        checked={singleUserData?.passwordNeverExpires}
                        disabled
                      ></Checkbox>
                      <span className='viewuser-checkbox-caption' style={{ marginLeft: '10px' }}>
                        Password never Expires
                      </span>
                    </DataContainer>
                    <DataContainer className='viewuser-item viewuser-item-disable'>
                      <Checkbox
                        className='viewuser-checkbox viewuser-checkbox-disable'
                        value='disable'
                        checked={!singleUserData?.isEnabled}
                        disabled
                      ></Checkbox>
                      <span className='viewuser-checkbox-caption' style={{ marginLeft: '10px' }}>
                        Account is disabled
                      </span>
                    </DataContainer>
                  </ViewRowWrapper>
                </div>
              </TabPane>
              <TabPane
                tab='Address'
                key='2'
                className='af-form-tab-tabpane af-viewuser-form-tab-tabpane af-viewuser-form-tab-tabpane_address'
              >
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap9'>
                  <DataContainer className='viewuser-item viewuser-item-street'>
                    <Label className='viewuser-label viewuser-label-street'>Street: </Label>
                    <Data className='viewuser-data viewuser-data-street'>{singleUserData?.street}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-country'>
                    <Label className='viewuser-label viewuser-label-country'>Country/Region: </Label>
                    <Data className='viewuser-data viewuser-data-country'>{singleUserData?.country}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap9'>
                  <DataContainer className='viewuser-label viewuser-label-state'>
                    <Label className='viewuser-label viewuser-label-state'>State/Province : </Label>
                    <Data className='viewuser-data viewuser-data-state'>{singleUserData?.state}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-city'>
                    <Label className='viewuser-label viewuser-label-city'>City: </Label>
                    <Data className='viewuser-data viewuser-data-city'>{singleUserData?.city}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap10'>
                  <DataContainer className='viewuser-item viewuser-item-po_box'>
                    <Label className='viewuser-label viewuser-label-po_box'>PO Box: </Label>
                    <Data className='viewuser-data viewuser-data-po_box'>{singleUserData?.poBox}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-postalcode'>
                    <Label className='viewuser-label viewuser-label-postalcode'>Zip/PostalCode :</Label>
                    <Data className='viewuser-data viewuser-data-postalcode'>{singleUserData?.zip}</Data>
                  </DataContainer>
                </ViewRowWrapper>
              </TabPane>
              <TabPane
                tab='Organization'
                key='3'
                className='af-form-tab-tabpane af-viewuser-form-tab-tabpane af-viewuser-form-tab-tabpane_organization'
              >
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap11'>
                  <DataContainer className='viewuser-item viewuser-item-jobtitle'>
                    <Label className='viewuser-label viewuser-label-jobtitle'>Job Title: </Label>
                    <Data className='viewuser-data viewuser-data-jobtitle'>{singleUserData?.jobTitle}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-department'>
                    <Label className='viewuser-label viewuser-label-department'>Department: </Label>
                    <Data className='viewuser-data viewuser-data-department'>{singleUserData?.department}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap12'>
                  <DataContainer className='viewuser-item viewuser-item-company'>
                    <Label className='viewuser-label viewuser-label-company'>Company: </Label>
                    <Data className='viewuser-data viewuser-data-company'>{singleUserData?.company}</Data>
                  </DataContainer>
                </ViewRowWrapper>
              </TabPane>
              <TabPane
                tab='Others'
                key='4'
                className='af-form-tab-tabpane af-viewuser-form-tab-tabpane af-viewuser-form-tab-tabpane_others'
              >
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap13'>
                  <DataContainer className='viewuser-item viewuser-item-description'>
                    <Label className='viewuser-label viewuser-label-description'>Description: </Label>
                    <Data className='viewuser-data viewuser-data-description'>{singleUserData?.description}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-office'>
                    <Label className='viewuser-label viewuser-label-office'>Office: </Label>
                    <Data className='viewuser-data viewuser-data-office'>{singleUserData?.office}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewuser-wrap viewuser-wrap-wrap14'>
                  <DataContainer className='viewuser-item viewuser-item-telephone'>
                    <Label className='viewuser-label viewuser-label-telephone'>Telephone Number: </Label>
                    <Data className='viewuser-data viewuser-data-telephone'>{singleUserData?.telephoneNumber}</Data>
                  </DataContainer>
                  <DataContainer className='viewuser-item viewuser-item-webpage'>
                    <Label className='viewuser-label viewuser-label-webpage'>Web Page: </Label>
                    <Data className='viewuser-data viewuser-data-webpage'>{singleUserData?.webPage}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                {renderAdditionalFields()}
              </TabPane>
            </Tabs>
          </ViewUserConatiner>
          <UserStatusBottomWrap className='af-viewuser-status-bottom-wrap' style={{ marginTop: 45 }}>
            <UserStatusContent className='af-viewuser-status-created-wrap'>
              <h4 className='af-viewuser-status-status-created-head'>Created:</h4>
              <span className='af-viewuser-status-status-created'>{singleUserData.createdAt}</span>
            </UserStatusContent>
            <UserStatusContent className='af-viewuser-status-status-lastChange-wrap'>
              <h4 className='af-viewuser-status-status-lastChange-head'>Last Changed:</h4>
              <span className='af-viewuser-status-status-lastChange'>{singleUserData.lastChanges}</span>
            </UserStatusContent>
          </UserStatusBottomWrap>
        </Modal>
      )}
    </>
  );
};

export default ViewUser;
